import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('deadline'),
    confirm: defineMessage('confirm'),
    optionNotSet: defineMessage('not_set_1'),
    optionBasedOnSubmission: defineMessage('based_on_submission_1'),
    optionBasedOnApproval: defineMessage('based_on_approval_1'),
    optionBasedOnDueDate: defineMessage('based_on_due_date'),
    optionBasedOnReview: defineMessage('based_on_the_start_of_the_review'),
    descriptionBasedOnSubmission: defineMessage('based_on_submission_dea__the_request_submission'),
    descriptionBasedOnApproval: defineMessage('based_on_approval_deadl_nters_the_approval_step'),
    descriptionBasedOnDueDate: defineMessage('based_on_due_date_deadl_he_due_date_minus_ndays'),
    descriptionBasedOnReview: defineMessage('based_on_start_of_the_r__enters_the_review_step'),
    errorEmpty: defineMessage('enter_a_time_value_for__lect_the_not_set_option'),
};
